import {
  FETCH_PRODUCTION_ACCUMULATED_REQUEST,
  FETCH_PRODUCTION_ACCUMULATED_SUCCESS,
  FETCH_PRODUCTION_ACCUMULATED_FAILURE,
  FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST,
  FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS,
  FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE,
  FETCH_JOB_HOURS_REQUEST,
  FETCH_JOB_HOURS_SUCCESS,
  FETCH_JOB_HOURS_FAILURE,
} from "../constants/ProductionConstant";

const initialState = {
  // Production Accumulated
  productionData: [],
  productionLoading: false,
  productionError: null,

  // IWO Groups
  IwoGroupData: [],
  iwoGroupLoading: false,
  iwoGroupError: null,

  // Job Hours
  JobHoursData: [],
  jobHoursLoading: false,
  jobHoursError: null,
};

const productionAccumulateReducer = (state = initialState, action) => {
  switch (action.type) {

    // ── Production Accumulated ──
    case FETCH_PRODUCTION_ACCUMULATED_REQUEST:
      return { ...state, productionLoading: true, productionError: null };
    case FETCH_PRODUCTION_ACCUMULATED_SUCCESS:
      return { ...state, productionLoading: false, productionData: action.payload };
    case FETCH_PRODUCTION_ACCUMULATED_FAILURE:
      return { ...state, productionLoading: false, productionError: action.payload };

    // ── IWO Group By Additional ──
    case FETCH_IWO_GROUP_BY_ADDITIONAL_REQUEST:
      return { ...state, iwoGroupLoading: true, iwoGroupError: null };
    case FETCH_IWO_GROUP_BY_ADDITIONAL_SUCCESS:
      return { ...state, iwoGroupLoading: false, IwoGroupData: action.payload };
    case FETCH_IWO_GROUP_BY_ADDITIONAL_FAILURE:
      return { ...state, iwoGroupLoading: false, iwoGroupError: action.payload };

    // ── Job Hours ──
    case FETCH_JOB_HOURS_REQUEST:
      return { ...state, jobHoursLoading: true, jobHoursError: null };
    case FETCH_JOB_HOURS_SUCCESS:
      return { ...state, jobHoursLoading: false, JobHoursData: action.payload };
    case FETCH_JOB_HOURS_FAILURE:
      return { ...state, jobHoursLoading: false, jobHoursError: action.payload };

    default:
      return state;
  }
};

export default productionAccumulateReducer;